const isIpad =
  typeof navigator !== "undefined" && /ipad|macintosh/i.test(navigator.userAgent) && "ontouchend" in document;
export const isMobile = isIpad || (typeof navigator !== "undefined" && /android|iphone/i.test(navigator.userAgent));
